import client from "./client";
import publicClient from "./publicClient";

// PUBLIC
export const getCompetitions = () =>
  publicClient.get("/public-competitions").then((res) => res.data);



// AUTH REQUIRED
export const joinCompetition = (id) =>
  client.post(`/competitions/${id}/join`).then(res => res.data);
